import _ from 'lodash';
var Questionnaire = {};

Questionnaire.install = function(Vue) {
  var coverdCounties = ["sanfrancisco","losangeles","orinda","fontana","sanmateo","sanmateocounty","pacifica","redwoodcity","sanjose"]
  var yes_no_answers = ["Yes", "No", "I don't know"];
  var allAvailableAnswers = {
    'organizationType': ['Government', 'Business'],
    'organizationCity': ['Oakland, CA'],
    'organizationSize': ['Fewer than 60,000 people', '60,000 - 200,000 people', 'More than 200,000 people'],
    'aduPrimarySource': [
      'California state law',
      'Local ADU ordinance',
      'Other',
    ],
    'aduPrimarySourcePlaceholders': [
      '',
      'Provide a link if available',
      "Tell us more"
    ],
    'organizationYesNoData': {
      "Parcel boundaries": yes_no_answers,
      "Zoning district boundaries": yes_no_answers,
      "Streets": yes_no_answers,
      "Building area & footprints": yes_no_answers,
    },
  };
  var contactItem = function(index, attribute) {
    return "symbium_contact_" + index + "_" + attribute;
  };

  var allContactIndexes = function() {
    var allKeys = Object.keys(window.localStorage)
    var contactKeys = _.filter(allKeys, function(key) {
      if (key.includes("symbium_contact_")) { return key; }
    });
    var duplicatedIndexes = _.map(contactKeys, function(key) {
      return parseInt(key.split('_')[2]);
    });
    return _.sortBy(_.uniq(duplicatedIndexes));
  }
  var contactAttributes = ["firstName", "lastName", "title", "email", "phone", "errors"];

  var keyFromId = function(id) {
    return 'symbium_' + id;
  }

  Vue.prototype.$questionnaire = {
    getAllAvailableAnswers: function() {
      return allAvailableAnswers;
    },
    getAnswer: function(id) {
      var key = keyFromId(id);
      return { id: id, value: window.localStorage.getItem(key) };
    },
    setAnswer: function(id, value) {
      var key = keyFromId(id);
      window.localStorage.setItem(key, value);
      return { id: id, value: window.localStorage.getItem(key) };
    },
    getContact: function(index) {
      var contact = {};
      _.each(contactAttributes, function(attribute) {
        contact[attribute] = window.localStorage.getItem(contactItem(index, attribute));
      });
      contact.errors = contact.errors || {};
      contact.dirty = contact.dirty || {};
      return Object.assign(contact, { index: index });
    },
    removeContact: function(index) {
      _.each(contactAttributes, function(attribute) {
        window.localStorage.removeItem(contactItem(index, attribute));
      });
      return this.getAllContacts();
    },
    setContactAttribute: function(index, attribute, value) {
      var item = contactItem(index, attribute);
      window.localStorage.setItem(item, value);
      return this.getContact(index);
    },
    getAllContacts: function() {
      var allContact = _.map(allContactIndexes(), (index) => { return this.getContact(index); });
      if (allContact.length == 0) {
        this.setContactAttribute(0, 'firstName', '')
        return [this.getContact(0)];
      } else {
        return allContact;
      }
    },
    clearContacts: function() {
      _.each(allContactIndexes(), (index) => { this.removeContact(index) });
    },
    clearData: function() {
      var allKeys = Object.keys(window.localStorage);
      var symbiumDataKeys = _.filter(allKeys, function(key) {
        if (key.includes("symbium_")) { return key; }
      });

      _.each(symbiumDataKeys, function(key) {
        window.localStorage.removeItem(key);
      });
    },
    isGovernment() {
      return this.getAnswer('organizationType').value == '0'
    },
    isBusiness() {
      return this.getAnswer('organizationType').value == '1'
    },
    validateContact(contact, attribute) {
      var error = null;
      if (attribute == 'email') {
        var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
        if (!emailRegex.test(contact.email)) {
          error = 'Invalid Email';
        }
      } else {
        if (!contact[attribute]) {
          error = `Required`
        }
      }
      return error;
    },
    checkDirty(contact) {
      var dirty = {};
      _.each(contactAttributes, function(attribute) {
        dirty[attribute] = contact.firstName ? true : false;
      });
      return dirty;
    },
    shouldBuildIncluded() {
      var city = this.getAnswer('organizationCity').value
      if(city && this.isGovernment()) {
        var county = city.split(',')[0]
        county = county.toLowerCase().replace(/[^a-zA-Z]+/g, "");
        return coverdCounties.indexOf(county) == -1;
      }
      return false;
    }
  }
};

export default Questionnaire;
